<template>
	<ValidationProvider
		name="payment_method_code"
		rules="required"
		v-slot="{ errors, valid }"
	>
		<v-card flat>
			<v-card-title primary-title :class="{ 'red--text': !valid }">
				{{ $t("title.payment_method") }}
				<v-icon right color="red" v-if="!valid">mdi-alert</v-icon>
			</v-card-title>
			<v-card-text>
				<v-list dense>
					<v-list-item-group
						v-model="item.payment_method_code"
						color="indigo"
						:error-messages="errors"
					>
						<template
							v-for="(payment_method, index) in payment_methods"
						>
							<v-list-item
								:key="`list-${index}`"
								:value="payment_method.code"
								outlined
							>
								<template v-slot:default="{ active }">
									<v-list-item-action>
										<v-img
											:src="payment_method.image_url"
											width="30"
											height="30"
											contain
										></v-img>
									</v-list-item-action>
									<v-list-item-content>
										<v-list-item-title>{{
											payment_method.name
										}}</v-list-item-title>
										<v-list-item-subtitle>
											<span
												v-html="
													payment_method.description
												"
											></span>
											<template
												v-if="payment_method.subtitle"
											>
												({{ payment_method.subtitle }})
											</template>
										</v-list-item-subtitle>
									</v-list-item-content>
									<v-list-item-action>
										<v-icon>
											{{
												active
													? "mdi-radiobox-marked"
													: "mdi-radiobox-blank"
											}}
										</v-icon>
									</v-list-item-action>
								</template>
							</v-list-item>
							<v-divider :key="`divider-${index}`"></v-divider>
						</template>
					</v-list-item-group>
				</v-list>
			</v-card-text>
		</v-card>
	</ValidationProvider>
</template>

<script>
export default {
	props: ["value", "payment_methods"],

	computed: {
		item: {
			get() {
				return this.value;
			},
			set(value) {
				this.$emit("input", value);
			},
		},
	},
};
</script>